import { DestroyRef, Directive, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroupDirective, Validators } from '@angular/forms';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';

import { FILTER_PATTERNS } from '@shared/constants';
import { distinctUntilChanged, tap } from 'rxjs';
import { DynamicPhoneValidationConfigInput } from './dynamic-phone-validation.model';

@Directive({ selector: '[appDynamicPhoneValidation]' })
export class DynamicPhoneValidationDirective implements OnInit {
  public phoneControlNames = input.required<DynamicPhoneValidationConfigInput>({
    alias: 'appDynamicPhoneValidation',
  });

  private readonly _formDirective = inject(FormGroupDirective);
  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit() {
    const form = this._formDirective.form;
    const prefixControl = form.get(this.phoneControlNames().prefix);
    const numberControl = form.get(this.phoneControlNames().number);

    prefixControl?.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap((prefixValue) => {
          if (prefixValue === DEFAULT_USA_PHONE_PREFIX) {
            numberControl?.setValidators([
              Validators.pattern(FILTER_PATTERNS.phoneNumberFormatted),
            ]);
            numberControl?.updateValueAndValidity();
          } else {
            numberControl?.setValidators([
              Validators.pattern(FILTER_PATTERNS.number),
            ]);
            numberControl?.updateValueAndValidity();
          }
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }
}
